import { render, staticRenderFns } from "./AudioPlayerPro.vue?vue&type=template&id=7b2d56fc"
import script from "./AudioPlayerPro.vue?vue&type=script&lang=js"
export * from "./AudioPlayerPro.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayerPro.vue?vue&type=style&index=0&id=7b2d56fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports